import type { LoaderFunctionArgs, MetaFunction } from "@remix-run/cloudflare";
import { motion } from "framer-motion";

import { item, Layout } from "~/components/site/layout";
import { ROUTE_DATA } from "~/lib/constants";
import { getMeta } from "~/lib/get-meta";
import { getUrls } from "~/lib/get-urls";

const { desc, path, title } = ROUTE_DATA.careers;

export function loader({ request }: LoaderFunctionArgs) {
  return { urls: getUrls({ path, request }) };
}

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return data ? getMeta({ desc, title, urls: data.urls }) : [];
};

export default function Careers(): JSX.Element {
  return (
    <Layout>
      <section className="section-first">
        <div className="container grid lg:grid-cols-3 items-start gap-16">
          <motion.h1 variants={item} className="h2 m-0 lg:sticky top-8">
            Careers at Brale
          </motion.h1>
          <motion.div variants={item} className="col-span-2 mt-2">
            <h2 className="h3 mt-0">The problem set</h2>
            <p>
              If you are interested in an opportunity at Brale, the following
              problem sets are likely interesting to you:
            </p>
            <ol>
              <li>
                How value can, could, or should move between decentralized and
                centralized finance
              </li>
              <li>
                How building systems more interplanetary by design can benefit
                billions of people
              </li>
              <li>
                How these solutions operate in symphony with the laws and
                regulations that support humankind
              </li>
              <li>
                Assessing contributions based on how we impact the market and
                the strength of our company
              </li>
              <li>Finding answers to questions not asked before</li>
            </ol>
            <p>
              Everyone has something they love. For some people, it&apos;s
              health science. For us, it&apos;s building computers that flip the
              bits that power economies and create opportunity.
            </p>
            <h2 className="h3">We have opinions</h2>
            <p>
              We believe the future of work should be defined by those who are
              doing it. The distributed nature of our team reflects the future
              of work and computing.
            </p>
            <h2 className="h3">We have values</h2>
            <p>
              Brale is an equal opportunity employer. We value ethics,
              curiosity, and capability. We have salaries with a 401k, health
              benefits, and the things you&apos;d come to expect from an
              employer in today&apos;s age.
            </p>
            <h2 className="h3">We are small and focused</h2>
            <p>
              We&apos;re 100% distributed, everyone gets equity, and we
              don&apos;t have education requirements. We seek kind, smart, and
              ambitious people to help us build computers that power value.
            </p>
            <h2 className="h3">We want to be a part of your future</h2>
            <p>
              We know and understand that roles change. Anyone who joins our
              team instantly becomes an important part of the Alumni of the
              company and we want to be an important partner for you in the long
              term. Many of us have worked together in the past and appreciate
              long-lasting relationships built while doing incredible work.
            </p>
            <h2 className="h3">We are ready for you</h2>
            <p>
              Brale is an engineering organization and you&apos;ll find that
              reflected in our team&apos;s behavior. You appreciate solid
              technical and product design and working with exceptional,
              like-minded engineers. Our team focuses on solving complex
              problems with simple solutions and continuously delivering them to
              customers.
            </p>
            <p>
              Due to an overwhelming response, we are halting new applications.
              Please{" "}
              <a
                href="https://airtable.com/shr03PvEoxrzskteo"
                className="underline underline-offset-4 hover:no-underline"
              >
                let us know
              </a>{" "}
              if you would like us to contact you when the application process
              re-opens.
            </p>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
}
